import { SearchCriteria } from '@apply/ui';
import { BfiApi, IApiResponse } from './bfiApi';
import { ISearchCriteria } from './common';

export interface AdminUserSearchCriteria extends SearchCriteria {
    isDeleted: boolean;
}

export interface IAdminUsersGrid {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
    lastActive?: Date;
    lastPasswordResetRequested?: Date;
    lastPasswordResetSent?: Date;
    lastFailedLoginAttempt?: Date;
    isLocked: boolean;
}

export interface IAdminUsersGridResponse extends Omit<IApiResponse, 'result'> {
    result: {
        totalCount: number;
        results: [IAdminUsersGrid];
    };
}

export class AdminApi extends BfiApi {
    getSettings(): Promise<IApiResponse> {
        return super.get('/admin/getSettings/');
    }

    updateSettings(model: any): Promise<IApiResponse> {
        return super.post('/admin/updateSettings/', model);
    }

    getAdminRoles(id: number): Promise<IApiResponse> {
        return super.get(`/admin/profiles/${id}/roles`);
    }

    updateAdminRoles(id: number, roleTypeIds: number[]): Promise<IApiResponse> {
        return super.post(`/admin/profiles/${id}/roles`, roleTypeIds);
    }

    async getAdminUsersGrid(criteria: ISearchCriteria): Promise<IAdminUsersGridResponse> {
        return super.post('/admin/profiles/grid', criteria);
    }

    getAdminUserProfile(id: number): Promise<IApiResponse> {
        return super.get(`/admin/profiles/${id}`);
    }

    updateAdminUserProfile(profile: any): Promise<IApiResponse> {
        return super.post(`/admin/profiles`, profile);
    }

    lockAdminUser(id: number, isLocked: boolean): Promise<IApiResponse> {
        return super.post(`/admin/profiles/${id}/lockout/${isLocked}`);
    }

    resetAdminUserPassword(id: number): Promise<IApiResponse> {
        return super.post(`/admin/profiles/${id}/passwordreset`);
    }

    deleteAdminUser(id: number, isDeleted: boolean): Promise<IApiResponse> {
        return super.delete(`/admin/profiles/${id}/delete/${isDeleted}`);
    }
}
